import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import { privateRoute, adminOnly, supervisorOnly } from './navGuards'
import lemmas from './routes/lemmas'
import texts from './routes/texts'

const routes: RouteRecordRaw[] = [
  {
    name: 'Portal Login',
    path: '/login',
    component: () => import('@/components/user/Login'),
  },
  {
    // Portal is the highest child in the router
    // this allows for default components (like the menu)
    // render on each view. It can also be extended to
    // have other default views
    path: '/',
    component: () => import('@/Portal'),
    meta: { private: true },
    beforeEnter: privateRoute,
    children: [
      ...lemmas,
      ...texts,
      {
        name: 'Home',
        path: '',
        component: () => import('@/components/home/Home'),
        beforeEnter: privateRoute,
      },
      {
        name: 'Portal Notifications',
        path: 'notifications',
        component: () => import('@/components/notifications/Notifications'),
        meta: { private: true },
        beforeEnter: adminOnly,
        children: [
          {
            path: 'message/:id',
            component: null,
          },
        ],
      },
      {
        // Supervisor-facing review queue. The guard only hides the route —
        // the API returns an empty queue to anyone who supervises nobody.
        name: 'Review Queue',
        path: 'reviews',
        component: () => import('@/components/reviews/ReviewQueue'),
        meta: { private: true },
        beforeEnter: supervisorOnly,
      },
      {
        name: 'Translators',
        path: 'translators',
        component: () => import('@/components/translators/list/Translators'),
        meta: { private: true },
        beforeEnter: privateRoute,
      },
      {
        name: 'Witnesses',
        path: 'witnesses',
        component: () => import('@/components/witnesses/list/Witnesses'),
        meta: { private: true },
        beforeEnter: privateRoute,
      },
      {
        name: 'Contributor',
        path: 'contributor',
        component: () => import('@/components/contributors/Contributor'),
        meta: { private: true },
        beforeEnter: privateRoute,
      },
      {
        name: 'Admin',
        path: 'admin',
        component: () => import('@/components/admin/Admin'),
        meta: { private: true },
        beforeEnter: adminOnly,
      },
      {
        name: 'Editor',
        path: 'editor',
        component: () => import('@/components/editor/Editor'),
        meta: { private: true },
        beforeEnter: adminOnly,
      },
      {
        name: 'Archive',
        path: 'archive',
        component: () => import('@/components/archive/Archive'),
        meta: { private: true },
        beforeEnter: privateRoute,
      },
      {
        name: 'Settings',
        path: 'settings',
        component: () => import('@/components/settings/Settings'),
        meta: { private: true },
        beforeEnter: privateRoute,
      },
      {
        name: 'Help',
        path: 'help',
        component: () => import('@/components/help/Help'),
        meta: { private: true },
        beforeEnter: privateRoute,
      },
      {
        name: 'PreFetchQueue',
        path: '/loading',
        component: () => import('@/components/global/loading/PreFetchQueue'),
        meta: { private: true },
        beforeEnter: privateRoute,
      },
    ] as RouteRecordRaw[],
  },
  {
    path: '/:catchAll(.*)',
    component: () => import('@/components/global/NotFound'),
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach(({}, {}) => {
  // TODO: implement elegant solution for guarding routes
  // const guards = [
  //   newLemma(store as Store<HexaplaState>),
  // ]

  return true
})

export default router
